const SEARCH_COOKIE_NAME = "recentSearches";
const MAX_RECENT_SEARCHES = 5; // Limit the number of recent searches
const $searchButton = $('.search-modal__form-button');
var $searchText = $('.search-modal__form-input');
const $searchSpinner = $('.search-modal__form-loading');
const $searchResults = $('.search-modal__results-wrapper');
var className = '';
// set a cookie
function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        let date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

// cookie by name
function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for(let i=0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}
        
function getRecentSearches() {
    const searchesString = getCookie(SEARCH_COOKIE_NAME);
    if (searchesString) {
        try {
            return JSON.parse(searchesString);
        } catch (e) {
            console.error("Error parsing recent searches cookie:", e);
            return [];
        }
    }
    return [];
}
function getPopularContent() {
     
    var popularContentSearchList = $('.js-popular-content-search > ul');
    popularContentSearchList.empty();
    $.ajax({
            url: "/umbraco/surface/PopularSearch/GetPopularSearchesOrContent",
            type: "GET",
            data: { type: 'content-click' },
            dataType: "json",
            success: function (response) { 
                if(response && Array.isArray(response.data) && response.data.length > 0)
                {
                    $('.js-popular-content-search').show();
                     response.data.forEach(item => {
                        const listItem = document.createElement('li');
                        const anchor = document.createElement('a'); 
                        anchor.href = item.url;
                        anchor.textContent = item.title;
                        listItem.appendChild(anchor);
                        popularContentSearchList.append(listItem);
                     });
                }else{
                    $('.js-popular-content-search').hide();
                }
            }
        });
}
function getPopularSearches() { 
    var popularKeywordSearchList = $('.js-popular-keyword-search > ul');
    popularKeywordSearchList.empty();
    $.ajax({
            url: "/umbraco/surface/PopularSearch/GetPopularSearchesOrContent",
            type: "GET",
            data: { type: 'searches' },
            dataType: "json",
            success: function (response) { 
                if(response && Array.isArray(response.data) && response.data.length > 0)
                {
                    $('.js-popular-keyword-search').show();
                     response.data.forEach(item => {
                        const listItem = document.createElement('li');
                        const anchor = document.createElement('a'); 
                        anchor.textContent = item;
                        listItem.appendChild(anchor); 
                        popularKeywordSearchList.append(listItem);
                     });
                }else{
                    $('.js-popular-keyword-search').hide();
                }
            },
            complete: function(){ 
                const $popularLinks = $('.search-modal__popular-item:not(.js-popular-content-search) a');
                $popularLinks.on('click', function(e){
                    $('.search-modal__popular').hide();  
                    const linkText = $(this).text();
                    $searchText.val(linkText);
                 
                }); 
            }
        });
}
function saveRecentSearch(query) {
    let searches = getRecentSearches();

    // Convert query to lowercase for case-insensitive comparison
    const normalizedQuery = query.toLowerCase();

    // Remove duplicates (optional)
    searches = searches.filter(s => s.toLowerCase() !== normalizedQuery);

    // Add the new query to the beginning
    searches.unshift(query);

    // Trim the array to the maximum limit
    if (searches.length > MAX_RECENT_SEARCHES) {
        searches = searches.slice(0, MAX_RECENT_SEARCHES);
    }

    setCookie(SEARCH_COOKIE_NAME, JSON.stringify(searches), 30); // Store for 30 days
}

function displayRecentSearchesBlock() {
    const recentSearches = getRecentSearches();
    getPopularSearches(); 
    getPopularContent();  
    const recentSearchesList = $('.js-popular-recent-searches > ul');
    recentSearchesList.empty(); // Clear recent searches display

    if (recentSearches.length > 0 ||
        $('.js-popular-keyword-search > ul > li').length > 0 ||
        $('.js-popular-content-search > ul > li').length > 0) {
        
         
    }  

    // Update recent searches display
    if (recentSearches.length > 0) {
        $('.js-popular-recent-searches').show();
        recentSearches.forEach(search => {
            const listItem = document.createElement('li');
            const anchor = document.createElement('a'); 
            anchor.textContent = search;
            listItem.appendChild(anchor);
            recentSearchesList.append(listItem);
        });
        const $popularLinks = $('.search-modal__popular-item:not(.js-popular-content-search) a');
        $popularLinks.on('click', function(e){
            $('.search-modal__popular').hide();  
            const linkText = $(this).text();
            $searchText.val(linkText);
            $searchButton.trigger('click');
        });
    } else {
        $('.js-popular-recent-searches').hide();
    }
 
}
window.displayRecentSearchesBlock = displayRecentSearchesBlock; 
  
$(document).ready(function () {
    // Hides spinner
    $searchSpinner.hide(); 
    if($('.search-modal__results-filter').length==0){
        // Display recent searches block on page load
        displayRecentSearchesBlock(); 
    }else{
        $('.search-modal__popular').hide();
    }
    
    if(window.location.search==''){
        $('.search-modal__popular').removeClass('d-done');
    }
     
     
    $('#PopularSearchForm').on('submit', function(event) {
        
        // Get its value and trim any leading/trailing whitespace
        const searchTermValue = $searchText.val().trim();

        // Check if the search term is empty
        if (searchTermValue === '') { 
            // Prevent the form from submitting
            event.preventDefault(); 
        }else{ saveRecentSearch(searchTermValue);}
        
    });
 

     
    
    const $resultsfilterlink = $('.search-modal__results-filter__list-item > a');
    $resultsfilterlink.on('click', function (e) { 
    
        e.preventDefault();
        var _eid = $(this).data('eid'); 
        
        $resultsfilterlink.removeClass('is-active'); 
        $(this).addClass('is-active');
        if(_eid == 'all') { 
                className = ''; 
            }
        if(_eid == 'pages') { 
            className = '.js-pages';  
        }
        if(_eid == 'resources') {
            className = '.js-resources';  
        }
        if(_eid == 'resourcedownload') {
            className = '.js-resourcedownload';  
            }
        if(_eid == 'news-pdf') {
            className = '.js-news';  
        }
        if(_eid == 'archived') {
            className = '.js-archived';  
        }
            
        $('.search-modal__results .search-modal__results-item').addClass('d-done'); 
        $(".search-modal__results .search-modal__results-item"+className+".d-done").slice(0, 12).removeClass('d-done');
        if ($(".search-modal__results .search-modal__results-item"+className+".d-done").length == 0) {
            $("#loadmore-results").addClass('d-done');
        }else{
            $("#loadmore-results").removeClass('d-done');
        }
                
    });
    $('.search-modal__results .search-modal__results-item').addClass('d-done'); 
    
    $(".search-modal__results .search-modal__results-item"+className+".d-done").slice(0, 12).removeClass('d-done');
    if ($(".search-modal__results .search-modal__results-item"+className+".d-done").length == 0) {
        $("#loadmore-results").addClass('d-done');
    }else{
        $("#loadmore-results").removeClass('d-done');
    }
    $("#loadmore-results").on('click', function (e) { 
        $(".search-modal__results .search-modal__results-item"+className+".d-done").slice(0, 12).removeClass('d-done');
        if ($(".search-modal__results .search-modal__results-item"+className+".d-done").length == 0) {
            $("#loadmore-results").addClass('d-done');
        }else{
                $("#loadmore-results").removeClass('d-done');
        }
    });
    if(window.location.search!=''){
        const urlObj = new URL(window.location.href);
        const params = new URLSearchParams(urlObj.search);
        const searchTerm = params.get('term');
        $searchText = $('.before-search-submit .search-modal__form-input');
        if(searchTerm!=null && searchTerm!=''){ $searchText.val(searchTerm);}
    } 
});

